import { render, staticRenderFns } from "./CreateBasicPointSettings.vue?vue&type=template&id=747befed&scoped=true&"
import script from "./CreateBasicPointSettings.vue?vue&type=script&lang=js&"
export * from "./CreateBasicPointSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747befed",
  null
  
)

export default component.exports